import { authenticatedAxios, nonAuthenticatedAxios } from "../utils/apiService";
import {
  removeDataFromLocalStorage,
  storeDataInLocalStorage,
  clearLocalStorage,
} from "../utils/localStorage";

export const loginAction = async (payload, setApiError, login, setLoading) => {
  setLoading(true);
  try {
    const res = await nonAuthenticatedAxios.post("/v1/clinic/sign-in", payload);
    const { accessToken, refreshToken, userData, clinicData } = res.data.data;
    setLoading(false);
    login({
      accessToken,
      refreshToken,
      data: {
        ...userData,
      },
    });
    clinicData && storeDataInLocalStorage("clinicData", clinicData);
  } catch (error) {
    setLoading(false);
    setApiError(error?.response?.data?.message || "Something went wrong.");
  }
};

export const logoutAction = async (setUser) => {
  window.startLoading();
  try {
    await authenticatedAxios.delete("/v1/clinic/sign-out");
    clearLocalStorage();
    setUser(null);
    window.stopLoading();
  } catch (error) {
    clearLocalStorage();
    setUser(null);
    window.stopLoading();
  }
};
